import _cloneDeep from 'lodash/cloneDeep';
import actions from './actions';
import { createReducer } from '../../../helpers/reducer';
import { t } from '../../../i18n';

const initState = {
  data: [],
  filteredTotal: 0,
  filters: [],
  loading: false,
  sortableColumns: [],
  total: 0,
};

function onLoadRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal, filters, sortableColumns } = payload;

  return {
    ...state,
    data,
    filteredTotal,
    filters,
    loading: false,
    sortableColumns,
    total,
  };
}

function onLoadError(state) {
  return {
    ...state,
    data: [],
    filteredTotal: 0,
    loading: false,
    total: 0,
  };
}

function onReinviteActionSuccess(state, { payload }) {
  return _cloneDeep({
    ...state,
    data: state.data.map(item => {
      const newItem = _cloneDeep(item);

      if (newItem.id === payload.id) {
        newItem.status = { id: 'resent', name: t('dash.agencies.invite.resent_status') };
        newItem.sent_at = new Date();
        newItem.isBold = true;
      }

      return newItem;
    }),
  });
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD_REQUEST]: onLoadRequest,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.LOAD_ERROR]: onLoadError,
  [actions.REINVITE_ACTION_SUCCESS]: onReinviteActionSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
